/*
  ORIGIN COMICS — fiche produit (étape 3)
  - note des lecteurs sous le titre (critiques de la communauté) et nombre d'avis dans l'onglet « Avis »
  - bouton « Ajouter à ma liste À lire » (même liste que dans le bloc Critiques)
  - badges (Coup de cœur, Nouveauté…) posés sur la photo
  - liens « Avis » : descendent jusqu'au bloc d'avis et ouvrent le bon onglet
  - onglet actif de la Fiche comics selon l'endroit où l'on se trouve
  Chargé par snippets/oc-produit.liquid et sections/oc-fiche-produit.liquid.
*/

const PROXY = '/apps/communaute';

function esc(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}

function plural(n, one, many) {
  return n + ' ' + (n > 1 ? many : one);
}

function starsHtml(average) {
  const pct = Math.max(0, Math.min(100, (Number(average) || 0) * 20));
  const row = '★★★★★';
  return '<span class="oc-pp-stars" aria-hidden="true"><span class="oc-pp-stars__base">' + row + '</span>' +
    '<span class="oc-pp-stars__fill" style="width:' + pct + '%">' + row + '</span></span>';
}

/* ---------- Données du comics (une seule requête pour la note et la liste « À lire ») ---------- */
const cache = new Map();
function loadWork(productId) {
  if (!cache.has(productId)) {
    cache.set(productId, fetch(PROXY + '/works/' + encodeURIComponent(productId), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then((res) => (res.ok ? res.json() : null)).catch(() => null));
  }
  return cache.get(productId);
}

/* ---------- Bloc d'avis de l'application ---------- */
function reviewsBlock() {
  return document.querySelector('[data-oc-reviews]');
}

function goToReviews(tab) {
  const block = reviewsBlock();
  if (!block) return false;
  const button = block.querySelector('[data-oc-tab="' + tab + '"]');
  if (button && button.getAttribute('aria-selected') !== 'true') button.click();
  block.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-oc-pp-goto]');
  if (!link) return;
  if (goToReviews(link.dataset.ocPpGoto === 'buyers' ? 'buyers' : 'reads')) event.preventDefault();
});

function decorateReviews() {
  const block = reviewsBlock();
  if (!block || block.dataset.ocPpDecorated) return;
  const heading = block.querySelector('.oc-rev__heading');
  if (!heading) return;
  block.dataset.ocPpDecorated = 'true';
  block.id = block.id || 'oc-avis';
  // « Avis des lecteurs » : le dernier mot en jaune
  const text = heading.textContent.trim();
  const cut = text.lastIndexOf(' ');
  if (cut > 0 && !heading.querySelector('span')) {
    heading.innerHTML = esc(text.slice(0, cut + 1)) + '<span>' + esc(text.slice(cut + 1)) + '</span>';
  }
}

/* ---------- Note sous le titre + nombre d'avis dans l'onglet ---------- */
function initRating(box) {
  if (box.dataset.ocPpReady) return;
  box.dataset.ocPpReady = 'true';
  const reads = box.querySelector('[data-oc-pp-goto="reads"]');
  const buyersLink = box.querySelector('[data-oc-pp-goto="buyers"]');
  const buyers = buyersLink ? parseInt(buyersLink.textContent, 10) || 0 : 0;

  loadWork(box.dataset.productId).then((data) => {
    const summary = (data && data.summary) || { count: 0, average: null };
    const count = Number(summary.count) || 0;
    if (count > 0 && summary.average != null) {
      const avg = String(Math.round(Number(summary.average) * 10) / 10).replace('.', ',');
      reads.innerHTML = starsHtml(summary.average) + '<strong>' + esc(avg) + '</strong>' +
        '<span>' + esc(plural(count, 'critique de lecture', 'critiques de lecture')) + '</span>';
      reads.setAttribute('aria-label', 'Note des lecteurs : ' + avg + ' sur 5, ' + plural(count, 'critique', 'critiques'));
    } else {
      reads.innerHTML = starsHtml(0) + '<span>Pas encore noté · sois le premier</span>';
    }
    box.classList.add('is-ready');

    const total = count + buyers;
    document.querySelectorAll('[data-oc-fp-avis-count]').forEach((el) => {
      el.textContent = total > 0 ? ' (' + total + ')' : '';
    });

    document.querySelectorAll('[data-oc-pp-toread]').forEach((btn) => setToRead(btn, Boolean(data && data.toRead)));
  });
}

/* ---------- Liste « À lire » ---------- */
const BOOKMARK_LABEL = { on: 'Dans ma liste « À lire »', off: 'Ajouter à ma liste « À lire »' };

function setToRead(btn, listed) {
  btn.setAttribute('aria-pressed', String(listed));
  const label = btn.querySelector('[data-oc-pp-toread-label]');
  if (label) label.textContent = listed ? BOOKMARK_LABEL.on : BOOKMARK_LABEL.off;
}

// Garde le bouton du bloc Critiques à jour (il lit aria-pressed au prochain clic)
function syncReviewsButton(listed) {
  const block = reviewsBlock();
  const other = block && block.querySelector('[data-oc-toread]');
  if (!other) return;
  other.setAttribute('aria-pressed', String(listed));
  const svg = other.querySelector('svg');
  if (svg) svg.setAttribute('fill', listed ? '#FFD338' : 'none');
  const textNode = [...other.childNodes].reverse().find((n) => n.nodeType === 3 && n.textContent.trim());
  if (textNode) textNode.textContent = listed ? BOOKMARK_LABEL.on : BOOKMARK_LABEL.off;
}

function initToRead(btn) {
  if (btn.dataset.ocPpReady) return;
  btn.dataset.ocPpReady = 'true';
  const msg = btn.parentElement.querySelector('[data-oc-pp-toread-msg]');
  btn.addEventListener('click', () => {
    const add = btn.getAttribute('aria-pressed') !== 'true';
    btn.disabled = true;
    fetch(PROXY + '/a-lire', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ productId: btn.dataset.productId, add })
    })
      .then((res) => res.json().catch(() => ({})).then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        btn.disabled = false;
        if (!ok) {
          if (msg) {
            msg.hidden = false;
            msg.innerHTML = data.code === 'NO_PROFILE'
              ? esc(data.error) + ' <a href="/account">Créer mon profil</a>'
              : esc(data.error || 'Une erreur est survenue, réessaie dans un instant.');
          }
          return;
        }
        if (msg) { msg.hidden = true; msg.innerHTML = ''; }
        setToRead(btn, Boolean(data.toRead));
        syncReviewsButton(Boolean(data.toRead));
      })
      .catch(() => {
        btn.disabled = false;
        if (msg) { msg.hidden = false; msg.textContent = 'Connexion impossible, réessaie dans un instant.'; }
      });
  });
}

/* ---------- Badges sur la photo ---------- */
function moveBadges() {
  const badges = document.querySelector('.product-info__block-item[data-block-type="badges"] .product-info__badge-list');
  const media = document.querySelector('.shopify-section--main-product .product-gallery__media-list-wrapper');
  if (!badges || !media || media.querySelector('.oc-pp-badges')) return;
  badges.classList.add('oc-pp-badges');
  media.appendChild(badges);
}

/* ---------- Onglets de la Fiche comics ---------- */
function initTabs(nav) {
  if (nav.dataset.ocPpReady) return;
  nav.dataset.ocPpReady = 'true';
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const targets = links
    .map((a) => ({ a, el: a.getAttribute('href') === '#oc-avis' ? reviewsBlock() : document.querySelector(a.getAttribute('href')) }))
    .filter((t) => t.el);
  if (!targets.length) return;
  const setActive = (a) => links.forEach((l) => l.classList.toggle('is-active', l === a));
  setActive(targets[0].a);
  const onScroll = () => {
    const line = window.innerHeight * 0.35;
    // le bloc le plus bas déjà passé sous la ligne (Résumé et Détails côte à côte : Résumé gagne)
    let current = targets[0];
    let best = -Infinity;
    targets.forEach((t) => {
      const top = t.el.getBoundingClientRect().top;
      if (top <= line && top > best + 1) { best = top; current = t; }
    });
    setActive(current.a);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ---------- Démarrage (et à chaque nouveau rendu dans l'éditeur de thème) ---------- */
function init() {
  moveBadges();
  decorateReviews();
  document.querySelectorAll('[data-oc-pp-rating]').forEach(initRating);
  document.querySelectorAll('[data-oc-pp-toread]').forEach(initToRead);
  document.querySelectorAll('[data-oc-fp-tabs]').forEach(initTabs);
}

init();
// Le bloc d'avis est construit par l'application après le chargement : on le décore dès qu'il apparaît
const observer = new MutationObserver(() => {
  decorateReviews();
  if (reviewsBlock() && reviewsBlock().dataset.ocPpDecorated) observer.disconnect();
});
observer.observe(document.body, { childList: true, subtree: true });
setTimeout(() => observer.disconnect(), 15000);
document.addEventListener('shopify:section:load', init);
